const $ = jQuery;

class ScrollTo {
	init() {
		$(document).on('click', '[data-scroll-to]', this.scrollToSection);
	}

	scrollToSection(e) {
		e.preventDefault();
		let $target = '';
		let headerHeight = $('header.main-header').outerHeight();
		if ($('#wpadminbar').length > 0) {
			headerHeight += $('#wpadminbar').outerHeight();
		}

		if ('#' !== $(this).attr('href') && $($(this).attr('href')).length > 0) {
			$target = $($(this).attr('href'));
		} else {
			$target = $(this).closest('section').next();
		}

		if ($target) {
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $target.offset().top - headerHeight,
				},
				500
			);
		}
	}
}

export default new ScrollTo();
